import React from "react";

const WarningIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.50397 2.87247C5.94211 1.9336 6.88439 1.3335 7.92046 1.3335H8.07941C9.11548 1.3335 10.0578 1.9336 10.4959 2.87247L14.6719 11.8211C15.2907 13.147 14.3228 14.6668 12.8595 14.6668H3.14033C1.67709 14.6668 0.709178 13.147 1.32796 11.8211L5.50397 2.87247ZM7.99993 4.00016C8.36812 4.00016 8.6666 4.29864 8.6666 4.66683V9.3335C8.6666 9.70169 8.36812 10.0002 7.99993 10.0002C7.63174 10.0002 7.33327 9.70169 7.33327 9.3335V4.66683C7.33327 4.29864 7.63174 4.00016 7.99993 4.00016ZM7.99993 12.3335C8.46017 12.3335 8.83327 11.9604 8.83327 11.5002C8.83327 11.0399 8.46017 10.6668 7.99993 10.6668C7.5397 10.6668 7.1666 11.0399 7.1666 11.5002C7.1666 11.9604 7.5397 12.3335 7.99993 12.3335Z"
        fill="#FFB200"
      />
    </svg>
  );
};

export default WarningIcon;
